var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isPlatformBrowser } from '@angular/common';
var Facebook = /** @class */ (function () {
    function Facebook(config, platformId) {
        this.config = config;
        this.platformId = platformId;
        this.isEnabled = false;
        if (this.config.appId && isPlatformBrowser(this.platformId)) {
            this.isEnabled = true;
        }
    }
    Object.defineProperty(Facebook.prototype, "appId", {
        get: function () {
            return this.config.appId;
        },
        enumerable: true,
        configurable: true
    });
    Facebook.prototype.getUserDetails = function (userAuthResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var userPromise, picPromise, userResponse, picResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isEnabled) {
                            return [2 /*return*/, undefined];
                        }
                        return [4 /*yield*/, this.loadSdk()];
                    case 1:
                        _a.sent();
                        userPromise = new Promise(function (resolve, reject) {
                            window.FB.api("/me", {
                                fields: 'email, first_name',
                                access_token: userAuthResponse.accessToken,
                            }, function (response) {
                                resolve(response);
                            });
                        });
                        picPromise = new Promise(function (resolve, reject) {
                            window.FB.api("/me/picture", {
                                redirect: false,
                                access_token: userAuthResponse.accessToken,
                            }, function (response) {
                                resolve(response);
                            });
                        });
                        return [4 /*yield*/, userPromise];
                    case 2:
                        userResponse = _a.sent();
                        return [4 /*yield*/, picPromise];
                    case 3:
                        picResponse = _a.sent();
                        if (userResponse && !userResponse.error) {
                            return [2 /*return*/, {
                                    email: userResponse.email,
                                    name: userResponse.first_name,
                                    // don't block on not being able to fetch the profile pic
                                    profileUrl: picResponse && !picResponse.error ? picResponse.data.url : undefined,
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Facebook.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fbResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isEnabled) {
                            return [2 /*return*/, {
                                    status: 'error',
                                    errorCode: 'unknown',
                                }];
                        }
                        if (this.successfulLoginState) {
                            return [2 /*return*/, this.successfulLoginState];
                        }
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                window.FB.login(function (response) {
                                    resolve(response);
                                }, {
                                    scope: 'email, public_profile',
                                });
                            })];
                    case 1:
                        fbResponse = _a.sent();
                        if (fbResponse.status === 'connected' && fbResponse.authResponse) {
                            this.successfulLoginState = {
                                status: 'success',
                                result: fbResponse.authResponse,
                            };
                            return [2 /*return*/, this.successfulLoginState];
                        }
                        return [2 /*return*/, {
                                status: 'error',
                                errorCode: fbResponse.status,
                            }];
                }
            });
        });
    };
    Facebook.prototype.loadSdk = function () {
        var _this = this;
        if (this.loadedPromise) {
            return this.loadedPromise;
        }
        this.loadedPromise = new Promise(function (resolve, reject) {
            var appId = _this.config.appId;
            if (!appId || !_this.isEnabled) {
                resolve(true);
                return;
            }
            window.fbAsyncInit = function () {
                window.FB.init({
                    appId: appId,
                    autoLogAppEvents: true,
                    xfbml: false,
                    cookie: false,
                    status: true,
                    version: 'v3.2',
                });
                // fetch the login status before resolving initialisation
                // this prevents popups from being blocked when we call `login` later.
                window.FB.getLoginStatus(function (status) {
                    if (status.status === 'connected') {
                        _this.successfulLoginState = {
                            status: 'success',
                            result: status.authResponse,
                        };
                    }
                    resolve(true);
                });
            };
            if (document.getElementById('external-fb-sdk')) {
                return;
            }
            var e = document.createElement('script');
            e.src = 'https://connect.facebook.net/en_US/sdk.js';
            e.id = 'external-fb-sdk';
            e.onerror = reject;
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(e, s);
        });
        return this.loadedPromise;
    };
    return Facebook;
}());
export { Facebook };
